<div class="container">
  <div class="card">
    <div class="card-body">
      <!-- TÍTULO -->
      <div class="panel panel-primary">
        <div class="panel-heading custom-panel">
          <div class="titulo-painel">
            <h2>{{ tituloDaEtapaAtual }}</h2>
          </div>
        </div>
      </div>

      <div>
        <div class="form-group">
          <mat-divider fxFlex="1 0"></mat-divider>
        </div>

        <!-- MENSAGEM SUCESSO -->
        <div class="panel-heading custom-sub-panel">
          <div class="titulo-sub-painel">
            <h3 class="form-dados-marcacao-consulta-msg-sucesso">
              {{
                marcacoesProcedimento.length > 1
                  ? "Os exames abaixo foram marcados com sucesso."
                  : "O exame abaixo foi marcado com sucesso."
              }}
              Aguarde a impressão do seu comprovante.
            </h3>
          </div>
        </div>

        <!-- BOTÃO PDF ÚNICO -->
        <!-- <div class="form-group text-center">
          <button
              mat-raised-button
              color="primary"
            (click)="imprimirComprovantes()"
            [disabled]="!(marcacoesProcedimento?.length)"
            matTooltip="Gerar comprovante de todos os exames"
          >
            <mat-icon>picture_as_pdf</mat-icon>
            Gerar comprovante de todos os exames
          </button>
        </div> -->

        <!-- TABELA -->
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Exame</th>
                <th>Data / Hora</th>
                <th>Médico</th>
                <th>Valor</th>
                <!-- <th>Envio</th> -->
              </tr>
            </thead>

            <tbody>
              <tr
                *ngFor="
                  let marcacao of marcacoesProcedimento.length
                    ? marcacoesProcedimento
                    : [marcacaoProcedimento];
                  let i = index
                "
              >
                <!-- EXAME -->
                <td>
                  <div>{{ marcacao.procedimento.nome }}</div>

                  <div
                    *ngIf="marcacao.procedimento?.recomendacoes"
                    style="margin-top: 6px"
                  >
                    <button
                      mat-stroked-button
                      color="primary"
                      (click)="baixarRecomendacoesDoExame(marcacao)"
                    >
                      Recomendações
                    </button>
                  </div>
                </td>

                <!-- DATA / HORA -->
                <td>
                  {{ marcacao.pk.dataMarcacao | date: "dd/MM/yyyy" }}<br />
                  {{ marcacao.horaAtendimento | horaFormatadaPipe }}
                </td>

                <!-- MÉDICO -->
                <td>{{ marcacao.nomeMedico }}</td>

                <!-- VALOR -->
                <td>
                  {{ marcacao | moedaFormatadaProcedimentoPipe }}
                </td>

                <!-- ENVIO -->
                <!-- <td>
                  <button
                    mat-icon-button
                    color="primary"
                    (click)="enviarComprovantePorEmail(marcacao)"
                    matTooltip="Enviar por e-mail"
                  >
                    <mat-icon>email</mat-icon>
                  </button>

                  <button
                    mat-icon-button
                    color="primary"
                    (click)="enviarComprovantePorSMS(marcacao)"
                    [disabled]="marcacao.comprovanteSMSEnviado"
                    matTooltip="Enviar por SMS"
                  >
                    <mat-icon>phone_android</mat-icon>
                  </button>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>

        <!-- RECOMENDAÇÕES GERAIS -->
        <div
          *ngIf="temRecomendacoes"
          class="form-group botao-recomendacoes col-12"
        >
          <button
            mat-stroked-button
            color="primary"
            (click)="baixarRecomendacoesDoExame()"
          >
            Baixe aqui as recomendações para realização desse exame.
          </button>
        </div>

        <!-- AVISO -->
        <div class="form-group col-md-12">
          <label class="label-titulo-atencao">
            Atenção: Caso o comprovante não apareça na tela verifique as
            configurações de popup do seu navegador.
          </label>
        </div>

        <!-- BOTÕES FINAIS -->
       <div class="acoes-container">

  <div class="acoes-esquerda">
    <button
      type="button"
      (click)="telaAnterior()"
      mat-raised-button
      color="primary"
      matTooltip="Tela Inicial"
    >
      Ir para Tela Inicial
    </button>
  </div>

  <div class="acoes-direita">
    <button
      mat-raised-button
      color="success"
      (click)="imprimirComprovantes()"
      [disabled]="!marcacoesProcedimento?.length"
      matTooltip="Gerar comprovante de todos os exames"
    >
      <mat-icon>picture_as_pdf</mat-icon>
      Gerar comprovante
    </button>

    <button
      type="button"
      (click)="proximaTela()"
      mat-raised-button
      color="primary"
      matTooltip="Marcar outro paciente"
    >
      Marcar outro Paciente
    </button>

    <button
      type="button"
      (click)="marcarOutroExame()"
      mat-raised-button
      color="primary"
      matTooltip="Continuar Marcação"
    >
      Marcar outro Exame
    </button>
  </div>

</div>
      </div>
    </div>
  </div>
</div>
